import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";

// Get all products
export const getNoAgentProducts = async () => {
  try {
    const userOrg = useStore.userOrg();
    const  params =  { org_name: userOrg }
    return getFilteredWorkspaceData(`/noagentproducts/`, 'organization', { params });
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

// Get a single product by ID
export const getNoAgentProductById = async (id) => {
  try {
    const response = await workspace.get(`/noagentproducts/${id}/`, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching product with ID ${id}:`, error);
    throw error;
  }
};

// Create a new product
export const createNoAgentProduct = async (productData) => {
  try {
    const response = await workspace.post(`/noagentproducts/`, productData);
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};



export const uploadNoAgentProductChunk = async (productId, formData) => {
  try {
    const response = await workspace.post(
      `/noagentproducts/${productId}/chunks/`, 
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading chunk:", error);
    throw error;
  }
};

export const updateUsers = async (id, productData) => {
  try {
      const response = await workspace.post(`/noagentproducts/${id}/users/`, productData, {
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}

// Update an existing product
export const updateNoAgentProduct = async (id, productData) => {
  try {
    const response = await workspace.put(`/noagentproducts/${id}/`, productData);
    return response.data;
  } catch (error) {
    console.error(`Error updating product with ID ${id}:`, error);
    throw error;
  }
};

// Delete a product
export const deleteNoAgentProduct = async (id) => {
  try {
    const response = await workspace.delete(`/noagentproducts/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting product with ID ${id}:`, error);
    throw error;
  }
};
